import { Inject, Injectable } from '@angular/core';
import { AppSettings, StorageUtilityLib, USER_SESSION_TOKEN, UserSession } from '@thehubz/client/core';
import { AuthApiService } from '@thehubz/client/data-access-api';

@Injectable()
export class AppInitService {
  refreshTokenTime = AppSettings.REFRESH_TOKEN_CHECK_INTERVAL;

  constructor(
    @Inject(USER_SESSION_TOKEN) private userSessionToken: string,
    private authService: AuthApiService,
    private storageUtility: StorageUtilityLib,
  ) {}

  init() {
    return new Promise<void>((resolve) => {
      this.refreshTokens().then(() => {
        resolve();
      });
    });
  }

  refreshTokens() {
    return new Promise<void>((resolve) => {
      const userSession: UserSession = this.storageUtility.getLocalStorage(this.userSessionToken);
      if (userSession) {
        const refreshToken = userSession.refresh_token;
        if (refreshToken && userSession.expires_at) {
          if (+userSession.expires_at - this.refreshTokenTime <= Date.now()) {
            const data = {
              refresh_token: refreshToken,
            };
            this.authService.authControllerRefreshToken(data).subscribe(
              (res: any) => {
                userSession.access_token = res.access_token;
                userSession.expires_at = res.expires_at;
                this.storageUtility.setLocalStorage(this.userSessionToken, userSession);
                resolve();
              },
              (err: any) => {
                resolve();
              },
            );
          } else resolve();
        } else resolve();
      } else resolve();
    });
  }
}
